import React, { useEffect, useState } from "react";
// import Search from "../../components/Search";
// import { AuthContext } from "../../AuthContext";
// import { useMsal } from "@azure/msal-react";
// import { protectedResources } from "../../msalConfig";
// import _ from "lodash";
import { Switch } from "antd";
// import { NavBarAndLandingPageContext } from "../../NavBarContextAndLandingPageContext";
import { IoIosClose } from "react-icons/io";
import { IoIosArrowDown } from "react-icons/io";
// import { useLocation } from 'react-router-dom';

const AdvancedFilterComponent = (props) => {

  const {
    // datasource,
    layers,
    // schemas,
    // domain,
    orgmodel,
    classifications,
    platforms,
    products,
    // refreshFreq,
    sensitivities,
    assetTypes,
    fileFormats,
    certification,
    businesses,
    outputPorts,
    // selecteddatasource,
    // selecteddomain,
    selectedlayers,
    // selectedschema,
    selectedorgmodel,
    selectedbusinesses,
    selectedclassifications,
    selectedplatforms,
    selectedproducts,
    // selectedrefreshfreq,
    selectedsensitivities,
    selectedassetTypes,
    selectedfileFormats,
    selectedOutputPorts,
    // selectedcertification,
    selectedoutputportcontext
  } = props;
  // const [filterdata, setFilterData] = useState([]);

  // const { getToken, token, error } = useContext(AuthContext);
  // const account = instance.getActiveAccount();
  // const request = {
  //   scopes: protectedResources.databook.scopes,
  //   account: account,
  // };
  // const { roletoggle, searchKeyword } = useContext(NavBarAndLandingPageContext);
  // const { criteria, term } = searchKeyword;

  // const [openRefreshFreq, setOpenRefreshFreq] = useState(false);
  // const [openSchema, setOpenSchema] = useState(true);
  const [openOrgmodel, setOpenOrgmodel] = useState(false);
  const [openLayers, setOpenLayers] = useState(false);
  const [openBusinesses, setOpenBusinesses] = useState(false);
  const [openClassifications, setOpenClassifications] = useState(false);
  const [openPlatforms, setOpenPlatforms] = useState(false);
  const [openProducts, setOpenProducts] = useState(false);
  const [openSensitivities, setOpenSensitivities] = useState(false);
  const [openAssetTypes, setOpenAssetTypes] = useState(false);
  const [openFileFormats, setOpenFileFormats] = useState(false);
  const [openOutPutPort, setOpenOutPutPort] = useState(false);
  const [classificationlabel, setClassificationLabel] = useState([]);
  const [sensitivitylabel, setSensitivityLabel] = useState([]);



  // const searchschemas = (e) => {
  //   var searchresults = schemas.filter(function (searchStr) {
  //     return (
  //       searchStr
  //         ?.toLocaleLowerCase()
  //         .search(e.target.value.toLocaleLowerCase()) > -1
  //     );
  //   });

  //   // setFilterData(searchresults);
  // };

  const handleChange = (e) => {
    let value = e.target.value === "null" ? null : e.target.value;
    let action = e.target.name;
    props.handleAddAndRemoveFilter(action, value, e);
  };

  const removeFilter = (e) => {
    let value = e.currentTarget.value === "null" ? null : e.currentTarget.value;
    props.handleAddAndRemoveFilter(e.currentTarget.name, value, "");
  };

  useEffect(() => {
    if (classifications) {
      let array = classifications.map((classi) => {
        if (classi === null) {
          return { fqn: "null", label: "Blank" };
        } else {
          let labelValue = classi?.replace("securityclassification.", "");
          let classfictionValue =
            labelValue?.charAt(0)?.toUpperCase() + labelValue?.slice(1);
          return { fqn: classi, label: classfictionValue };
        }
      });
      let removeduplicate = array.filter(
        (obj1, i, arr) =>
          arr.findIndex((obj2) => obj2.fqn === obj1.fqn) === i
      );
      setClassificationLabel(removeduplicate);
    }

    if (sensitivities) {
      let sentivityArray = sensitivities
        ?.filter((obj1, i, arr) => arr.findIndex((obj2) => obj2 === obj1) === i)
        .sort()
        .map((sen) => {
          if (sen === null) {
            return { fqn: "null", label: "Blank" };
          } else {
            let senValue = "";
            if (sen.indexOf("confidential") > 0) {
              senValue =
                "Confidential " +
                sen?.replace("securityclassification.confidential.", "");
            } else if (sen.indexOf("internal") > 0) {
              senValue =
                "Internal " +
                sen?.replace("securityclassification.internal.", "");
            } else if (sen.indexOf("public")) {
              senValue =
                "Public " + sen?.replace("securityclassification.public.", "");
            }
            return { fqn: sen, label: senValue };
          }
        });
      setSensitivityLabel(sentivityArray);
    }

    // securityclassification.confidential.pci
    // sification.internal.pii
    // "securityclassification.public"
    // if ()



  }, [classifications, sensitivities])

  const sortAndRemoveDuplicates = (array) => {
    let blankItem = array.includes(null)
      ? [{ label: "Blank", value: "null" }]
      : [];
    let filteredArray = array
      .filter((item, index) => array.indexOf(item) === index && item !== null)
      .sort();
    return [
      ...blankItem,
      ...filteredArray.map((item) => ({ label: item, value: item })),
    ];
  };

  return (
    <div className="filter-panel text-dark">
      <div className="AFCsidebar">
        {/* {allSelectedFilter && allSelectedFilter.length > 0 ? ( */}
        <div className="sidebarInputWrapper">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: "0.4rem",
            }}
          >
            <p>Filter within results</p>
            <p className="clearAll" onClick={props.clearAllFilter}>
              Clear All
            </p>
          </div>
        </div>
        {props.allSelectedFilter && props.allSelectedFilter.length > 0 && (
          <div className="box1" style={{ paddingBottom: "1rem" }}>
            <div className="d-inline-block w-100">
              {props.allSelectedFilter?.map(
                (filter, index) =>
                  filter.value !== null && (
                    <div className="selected-filter-outer-div" key={index} >
                      <span
                        className="selected-filter-outer-span"
                        style={{ color: "#000000" }}
                      >
                        <span className="selected-filter-content-span">
                          {filter.filterType === "classifications" ||
                            filter.filterType === "sensitivities"
                            ? filter.label
                            : filter.value === "null"
                              ? ""
                              : filter.value}
                        </span>

                        {!(props.category === filter.filterType || filter.filterType == "outputPorts") ? (

                          <button
                            className="p-0 border-0"
                            name={filter.filterType}
                            value={
                              filter.value === "null" ? "null" : filter.value
                            }
                            onClick={removeFilter}
                          >
                            <span className="selected-filter-cancel-outer">
                              <span className="selected-filter-close">
                                <IoIosClose size={22} />
                              </span>
                            </span>
                          </button>
                        ) : ""}
                      </span>
                    </div>
                  )
              )}
            </div>
          </div>
        )}

        <div className="AFC-selected-filters d-flex w-100">
          <div className="" style={{ width: "100%" }}>
            {certification?.length > 0 && (
              <div className="filter-inner-div my-1">
                <label className="mt-1 filter-font">Certified dataset</label>
                <Switch
                  style={{
                    // backgroundColor: props.certifiedtoggle
                    backgroundColor: props.selectedcertification
                      ? "green"
                      : "lightgrey",
                    float: "right",
                    marginTop: "6px",
                  }}
                  size="small"
                  onChange={props.certifiedToggle}
                  checked={props.selectedcertification}
                />
              </div>
            )}
            <div className="filter-inner-div my-1">
              <label className="filter-font">Owned datasets</label>
              <Switch
                style={{
                  backgroundColor: props.filterOwnedDataset
                    ? "green"
                    : "lightgrey",
                  float: "right",
                  marginTop: "6px",
                }}
                size="small"
                onChange={props.filterOwnedDatasetfunc}
                checked={props.filterOwnedDataset}
              />
            </div>
          </div>
        </div>




        {/* Old Filters 3 Orgmodel*/}
        {orgmodel.length > 0 && (
          <div className="box1 btn-box "

          >
            <p
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
              className="curson-property"
              onClick={() => setOpenOrgmodel(!openOrgmodel)}
            >
              <span>Portfolio</span>
              <IoIosArrowDown
                size={14}
                style={
                  openOrgmodel
                    ? { cursor: "pointer", transform: "rotate(180deg)" }
                    : { cursor: "pointer" }
                }
              />
            </p>
            {openOrgmodel && (
              <div className="viewall-side-filter">
                {sortAndRemoveDuplicates(orgmodel).map((model, ind) => (
                  <div className="p-1 filter__cap" key={ind}>
                    <input
                      type="checkbox"
                      value={model.value === "null" ? "null" : model.value}
                      name="orgmodel"
                      onChange={handleChange}
                      checked={selectedorgmodel.includes(
                        model.value === "null" ? null : model.value
                      )}
                      disabled={
                        props.category === "Portfolio" &&
                        model.value === props.categoryValue
                      }
                    />
                    <span>{model.label}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {platforms.length > 0 && (
          <div className="box1 btn-box " >
            <p
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
              className="curson-property"
              onClick={() => setOpenPlatforms(!openPlatforms)}
            >
              <span>Platform</span>
              <IoIosArrowDown
                size={14}
                style={
                  openPlatforms
                    ? { cursor: "pointer", transform: "rotate(180deg)" }
                    : { cursor: "pointer" }
                }

              />
            </p>
            {openPlatforms && (
              <div className="viewall-side-filter">
                {sortAndRemoveDuplicates(platforms).map((plat, ind) => (
                  <div className="p-1 filter__cap" key={ind}>
                    <input
                      type="checkbox"
                      value={plat.value === "null" ? "null" : plat.value}
                      name="platforms"
                      onChange={handleChange}
                      checked={selectedplatforms.includes(
                        plat.value === "null" ? null : plat.value
                      )}
                      disabled={props.category === "Platform"}
                    />
                    <span>{plat.label}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {outputPorts.length > 0 && (
          <div className="box1 btn-box " >
            <p
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
              className="curson-property"
              onClick={() => setOpenOutPutPort(!openOutPutPort)}
            >
              <span>Output Ports</span>
              <IoIosArrowDown
                size={14}
                style={
                  openOutPutPort
                    ? { cursor: "pointer", transform: "rotate(180deg)" }
                    : { cursor: "pointer" }
                }

              />
            </p>
            {openOutPutPort && (
              <div className="viewall-side-filter">
                {sortAndRemoveDuplicates(outputPorts).map((plat, ind) => (
                  <div className="p-1 filter__cap" key={ind}>
                    <input
                      type="checkbox"
                      value={plat.value === "null" ? "null" : plat.value}
                      name="outputPorts"
                      onChange={handleChange}
                      checked={selectedOutputPorts.includes(
                        plat.value === "null" ? null : plat.value
                      )}
                      disabled={selectedoutputportcontext === plat.value}
                    />
                    <span>{plat.label}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* {businesses?.length > 0 && (
          <div className="box1 btn-box " >
            <p
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
              className="curson-property"
              onClick={() => setOpenBusinesses(!openBusinesses)}
            >
              <span>Business Capability</span>
              <IoIosArrowDown
                size={14}
                style={
                  openBusinesses
                    ? { cursor: "pointer", transform: "rotate(180deg)" }
                    : { cursor: "pointer" }
                }
              />
            </p>
            {openBusinesses && (
              <div className="viewall-side-filter">
                {businesses &&
                  businesses.length > 0 ? (
                  businesses?.sort()?.map((bus, ind) => (
                    <div className="p-1 filter__cap" key={ind}>
                      <input
                        type="checkbox"
                        value={bus && bus}
                        name="businesses"
                        onChange={handleChange}
                        checked={
                          selectedbusinesses.indexOf(bus) > -1 ? true : false
                        }
                        disabled={props.category === "Business Capability"}
                      />
                      <span>{bus}</span>
                    </div>
                  ))
                ) : (
                  ""
                )}
              </div>
            )}
          </div>
        )} */}


        {/* box 9 Products*/}
        {products.length > 0 && (
          <div className="box1 btn-box " >
            <p
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
              className="curson-property"
              onClick={() => setOpenProducts(!openProducts)}
            >
              <span>Product</span>
              <IoIosArrowDown
                size={14}
                style={
                  openProducts
                    ? { cursor: "pointer", transform: "rotate(180deg)" }
                    : { cursor: "pointer" }
                }

              />
            </p>
            {openProducts && (
              <div className="viewall-side-filter">
                {sortAndRemoveDuplicates(products).map((prod, ind) => (
                  <div className="p-1 filter__cap" key={ind}>
                    <input
                      type="checkbox"
                      value={prod.value === "null" ? "null" : prod.value}
                      name="products"
                      onChange={handleChange}
                      checked={selectedproducts.includes(
                        prod.value === "null" ? null : prod.value
                      )}
                      disabled={props.category === "Product"}
                    />
                    <span>{prod.label}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}



        {layers?.length > 0 && (
          <div className="box1 btn-box ">
            <p
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
              onClick={() => setOpenLayers(!openLayers)}
              className="curson-property"
            >
              <span>Storage Account</span>
              <IoIosArrowDown
                size={14}
                style={
                  openLayers
                    ? { cursor: "pointer", transform: "rotate(180deg)" }
                    : { cursor: "pointer" }
                }
              />
            </p>
            {openLayers && (
              <div className="viewall-side-filter">
                {sortAndRemoveDuplicates(layers).map((layer, ind) => (
                  <div className="p-1 filter__cap" key={ind}>
                    <input
                      type="checkbox"
                      value={layer.value === "null" ? "null" : layer.value}
                      name="layers"
                      onChange={handleChange}
                      checked={selectedlayers.includes(
                        layer.value === "null" ? null : layer.value
                      )}
                    />
                    <span>{layer.label}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* {schemas.length > 0 && (
          <div className="box1 btn-box " >
            <p
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
              className="curson-property"
              onClick={() => setOpenSchema(!openSchema)}
            >
              <span>Schemas</span>
              <IoIosArrowDown
                size={14}
              />
            </p>
            {openSchema && (
              <>
                <Search
                  divstyle=""
                  inputstyle="filter-input"
                  placeHolder="Search by fqn and schema"
                  iconSize={20}
                  innerwrapper="custom-border d-flex"
                  searchFunc={searchschemas}
                />
                <div className="viewall-side-filter">
                  {schemas && schemas.length > 0 ? (
                    schemas?.map(
                      (schema, ind) =>
                        schema && (
                          <div className="p-1 filter__cap" key={ind}>
                            <input
                              type="checkbox"
                              value={schema}
                              name="schemas"
                              onChange={handleChange}
                              checked={
                                selectedschema.indexOf(schema) > -1
                                  ? true
                                  : false
                              }
                            />

                            <span>{schema}</span>
                          </div>
                        )
                    )
                  ) : (
                    ""
                  )}
                </div>
              </>
            )}
          </div>
        )} */}
        {fileFormats.length > 0 && (
          <div className="box1 btn-box " >
            <p
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
              className="curson-property"
              onClick={() => setOpenFileFormats(!openFileFormats)}
            >
              <span>File Format</span>
              <IoIosArrowDown
                size={14}
                style={
                  openFileFormats
                    ? { cursor: "pointer", transform: "rotate(180deg)" }
                    : { cursor: "pointer" }
                }

              />
            </p>
            {openFileFormats && (
              <div className="viewall-side-filter">
                {sortAndRemoveDuplicates(fileFormats).map((file, ind) => (
                  <div className="p-1 filter__cap" key={ind}>
                    <input
                      type="checkbox"
                      value={file.value === "null" ? "null" : file.value}
                      name="formats"
                      onChange={handleChange}
                      checked={selectedfileFormats.includes(
                        file.value === "null" ? null : file.value
                      )}
                    />
                    <span>{file.label}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}


        {/* Old Filters 4 Datasource*/}
        {/* {datasource?.length > 0 && (
          <div className="box1 btn-box ">
            <p
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
              className="curson-property"
              onClick={() => setOpenDatasource(!openDatasource)}
            >
              <p>Datasource</p>
              <IoIosArrowDown
                size={14}
                style={
                  openDatasource
                    ? { cursor: "pointer", transform: "rotate(180deg)" }
                    : { cursor: "pointer" }
                }
                
              />
            </p>
            {openDatasource && (
              <div className="viewall-side-filter">
                { datasource &&
                  datasource.length > 0 &&
                  !loadingflagdatasource ? (
                  datasource?.map((source, ind) => (
                    <div className="p-1 filter__cap" key={ind}>
                      <input
                        type="checkbox"
                        value={source && source}
                        name="datasource"
                        onChange={handleChange}
                        checked={
                          selecteddatasource.indexOf(source) > -1 ? true : false
                        }
                      />
                      <span>{source}</span>
                    </div>
                  ))
                ) : (
                  ""
                )}
              </div>
            )}
          </div>
        )} */}

        {/* Old Filters 5 Layers*/}

        {/* box 6 Business*/}


        {/* box 7 Classifications*/}
        {classifications.length > 0 && (
          <div className="box1 btn-box " >
            <p
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
              className="curson-property"
              onClick={() => setOpenClassifications(!openClassifications)}
            >
              <span>Classification</span>
              <IoIosArrowDown
                size={14}
                style={
                  openClassifications
                    ? { cursor: "pointer", transform: "rotate(180deg)" }
                    : { cursor: "pointer" }
                }

              />
            </p>
            {openClassifications && (
              <div className="viewall-side-filter">
                {classificationlabel.map((clas, ind) => (
                  <div className="p-1 filter__cap" key={ind}>
                    <input
                      type="checkbox"
                      value={clas.fqn === "null" ? "null" : clas.fqn}
                      name="classifications"
                      data-classification={clas.label}
                      valuelabel={clas.label}
                      onChange={handleChange}
                      checked={selectedclassifications.includes(
                        clas.fqn === "null" ? null : clas.fqn
                      )}
                    />
                    <span>{clas.label}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* box 8 Platforms*/}



        {/* box 10 Refresh Freq*/}
        {/* {refreshFreq.length > 0 && (
          <div className="box1 btn-box ">
            <p
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
              className="curson-property"
            >
              <span>Refresh Frequencies</span>
              <IoIosArrowDown
                size={14}
                style={
                  openRefreshFreq
                    ? { cursor: "pointer", transform: "rotate(180deg)" }
                    : { cursor: "pointer" }
                }
                onClick={() => setOpenRefreshFreq(!openRefreshFreq)}
              />
            </p>
            {openRefreshFreq && (
              <div className="viewall-side-filter">
                { refreshFreq &&
                  refreshFreq.length > 0 &&
                  !loadingflagrefreshfreq ? (
                  refreshFreq?.map((reffeq, ind) => (
                    <div className="p-1 filter__cap" key={ind}>
                      <input
                        type="radio"
                        value={reffeq && reffeq}
                        name="refreshFrequencies"
                        onChange={handleChange}
                        // checked={
                        //   selectedrefreshfreq?.indexOf(reffeq) > -1
                        //     ? true
                        //     : false
                        // }
                        checked={selectedrefreshfreq == reffeq ? true : false}
                      />
                      <span>{reffeq}</span>
                    </div>
                  ))
                ) : (
                  ""
                )}
              </div>
            )}
          </div>
        )} */}

        {/* box 11 Sensitivities*/}
        {sensitivitylabel.length > 0 && (
          <div className="box1 btn-box ">
            <p
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
              className="curson-property"
              onClick={() => setOpenSensitivities(!openSensitivities)}
            >
              <span>Sensitivity</span>
              <IoIosArrowDown
                size={14}
                style={
                  openSensitivities
                    ? { cursor: "pointer", transform: "rotate(180deg)" }
                    : { cursor: "pointer" }
                }

              />
            </p>
            {openSensitivities && (
              <div className="viewall-side-filter">
                {sensitivitylabel.map((sense, ind) => (
                  <div className="p-1 filter__cap" key={ind}>
                    <input
                      type="checkbox"
                      // valuelabel={sense.fqn}
                      value={sense.fqn === "null" ? "null" : sense.fqn}
                      name="sensitivities"
                      data-sensitivity={sense.label}
                      onChange={handleChange}
                      checked={selectedsensitivities.includes(
                        sense.fqn === "null" ? null : sense.fqn
                      )}
                    />
                    <span>{sense.label}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* box 12 Asset Types*/}
        {assetTypes.length > 0 && (
          <div className="box1 btn-box " >
            <p
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
              className="curson-property"
              onClick={() => setOpenAssetTypes(!openAssetTypes)}
            >
              <span>Asset Type</span>
              <IoIosArrowDown
                size={14}
                style={
                  openAssetTypes
                    ? { cursor: "pointer", transform: "rotate(180deg)" }
                    : { cursor: "pointer" }
                }

              />
            </p>
            {openAssetTypes && (
              <div className="viewall-side-filter">
                {assetTypes.map((asset, ind) => (
                  <div className="p-1 filter__cap" key={ind}>
                    <input
                      type="checkbox"
                      value={asset === "null" ? "null" : asset}
                      name="assetTypes"
                      onChange={handleChange}
                      checked={selectedassetTypes.includes(
                        asset === "null" ? null : asset
                      )}
                    />
                    <span>{asset}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* box 13 File Formats*/}

      </div>

      <div className="filter-vertical-line"></div>
    </div>
  );
};

export default AdvancedFilterComponent;
